<template>
 <div class="reset-password">
   <div class="logo">
      <img src="~@/assets/flux-logo.svg">
   </div>
   <div class="form">
     <div class="title">Reset Password</div>
     <el-form>
      <el-form-item>
        <el-input v-model="newPassword" type="password" placeholder="Password" ref="newPassword">
          <font-awesome-icon icon="key" slot="suffix" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="confirmPassword" type="password" placeholder="Confirm Password" :class="{ invalid: newPassword != confirmPassword }">
          <font-awesome-icon icon="key" slot="suffix" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reset" :disabled="!passwordResetIsEnabled">Reset</el-button>
      </el-form-item>
    </el-form>
   </div>
 </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      newPassword: null,
      confirmPassword: null
    }
  },
  methods: {
    keypress (e) {
      e.keyCode === 13 && this.passwordResetIsEnabled && this.reset()
    },
    reset () {
      let sha1 = require('sha1')
      let authKey = sha1(this.newPassword)
      let url = `${this.$store.state.authentication.baseUrl}/reset`
      let data = {
        token: this.email,
        authKey: authKey
      }
      axios({ url: url, data: data, method: 'POST' })
        .then(response => {
          this.$router.push({ path: '/login', query: { resetToken: this.$route.params.token } })
        })
        .catch(() => this.$message.error('Failed to reset password.'))
    }
  },
  computed: {
    passwordResetIsEnabled () {
      return this.newPassword && this.confirmPassword && this.newPassword === this.confirmPassword
    }
  },
  mounted () {
    this.$nextTick(() => this.$refs['newPassword'].focus())
  },
  created () {
    document.addEventListener('keypress', this.keypress)
  },
  destroyed () {
    document.removeEventListener('keypress', this.keypress)
  }
}
</script>

<style lang='scss' >
  @import "../styles/common.scss";
  
  .reset-password {

    .logo {
      height: 200px;
      background-color: #2E314A;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    
      img {
        height:90px;
        width:200px;
        margin-bottom: 20px;
      }
    }
    .title {
      line-height: 24px;
      font-size: 22px;
      color: #303133;
      margin: 30px 0px 15px 0px;
    }
    .form {
      text-align: center;

      form {
        display: inline-block;
        width: 300px;

        button {
          width: 100%;
        }
        .invalid input:focus {
          border-color: $light-red;
        }
      }
    }
  }
</style>
